import React from 'react';
import { newToastMessageAsync } from '@Containers/ToastMessages/ToastMessagesActions';
import CopiedToastMessage from '@Containers/ToastMessages/CopiedToastMessage/CopiedToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showCopiedToastMessage = (message) =>
  newToastMessageAsync({
    title: <CopiedToastMessage message={message} />,
    color: 'confirm',
  });
